export function LegalMentions() {
  return (
    <div data-testid="legal-mentions" className="max-w-3xl mx-auto px-6 md:px-12 py-20 prose">
      <h1 className="font-serif text-5xl mb-8">Mentions légales</h1>
      <p><strong>Éditrice</strong> : Amélie — Les Rendez-vous de l'écriture</p>
      <p><strong>Adresse</strong> : 13 rue du Ferré, 57070 Metz, France</p>
      <p><strong>Email</strong> : amelie@lesrdvdelecriture.com</p>
      <p><strong>Hébergeur</strong> : Emergent (Kubernetes / Cloudflare). MongoDB pour la base de données.</p>
      <p className="mt-6 text-sm text-[#7C7064]">Directrice de la publication : Amélie. Numéro SIRET : 901 549 832 00037.</p>
    </div>
  );
}
export function CGV() {
  return (
    <div data-testid="cgv-page" className="max-w-3xl mx-auto px-6 md:px-12 py-20">
      <h1 className="font-serif text-5xl mb-8">Conditions générales de vente</h1>
      <div className="text-[#4A4036] space-y-4 leading-relaxed">
        <p>Les présentes CGV régissent les ventes réalisées sur le site Les RDV de l'écriture.</p>
        <h2 className="font-serif text-2xl mt-8">Produits</h2>
        <p>Le programme d'écriture (102€ ou 152€) et la correspondance manuscrite (35€ ou 59€).</p>
        <h2 className="font-serif text-2xl mt-8">Paiement</h2>
        <p>Paiement sécurisé Stripe. Prélèvement à la commande.</p>
        <h2 className="font-serif text-2xl mt-8">Droit de rétractation</h2>
        <p>Conformément au droit européen, tu disposes de 14 jours pour te rétracter, sauf pour les contenus déjà commencés (premier email envoyé) avec ton accord exprès.</p>
        <h2 className="font-serif text-2xl mt-8">Livraison</h2>
        <p>Coffrets envoyés sous 7 à 14 jours. Réponses manuscrites sous 2 semaines.</p>
        <p className="text-sm text-[#7C7064] mt-10">Version simplifiée — CGV complètes en cours d'établissement.</p>
      </div>
    </div>
  );
}
export function Privacy() {
  return (
    <div data-testid="privacy-page" className="max-w-3xl mx-auto px-6 md:px-12 py-20">
      <h1 className="font-serif text-5xl mb-8">Politique de confidentialité</h1>
      <div className="text-[#4A4036] space-y-4 leading-relaxed">
        <p>Tes données (email, prénom, adresse postale le cas échéant) sont utilisées uniquement pour t'envoyer les emails du programme et te répondre par courrier.</p>
        <p>Elles sont hébergées en Union européenne et conservées 3 ans après ta dernière commande.</p>
        <p>Tu peux à tout moment demander la suppression de tes données à amelie@lesrdvdelecriture.com — nous le faisons sous 30 jours.</p>
        <p>Analytics : Plausible (sans cookies, RGPD-compliant).</p>
        <p>En cas de détresse psychologique, appelle le 3114.</p>
      </div>
    </div>
  );
}
